import React from 'react';
import styled from 'styled-components';
import { Button } from 'components';

function DeleteCommentDialog({ onConfirm, onDismiss, deleting }) {
  return (
    <Container>
      <h2>Delete Comment</h2>
      <p>
        Are you sure you want to delete this comment?
        <br />
        This will also delete any replies to this comment.
      </p>
      <p className="warning">This action cannot be undone.</p>
      <ButtonContainer>
        <Button onClick={onDismiss} disabled={deleting} width="120px">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          loading={deleting}
          width="120px"
          backgroundColor="var(--red)">
          Delete
        </Button>
      </ButtonContainer>
    </Container>
  );
}

const Container = styled.section`
  background-color: #fff;
  border-radius: var(--border-radius-md);
  margin: 0 auto;
  max-width: 20.938rem;
  padding: 3.25rem 1.25rem 2.5rem;
  perspective: 50rem;
  position: relative;
  width: 100%;
  z-index: 1;

  @media (min-width: 1200px) {
    max-width: 28.375rem;
    padding: 3.25rem 1.875rem 2.5rem;
  }

  h2,
  p {
    text-align: center;
  }

  p {
    margin-bottom: 1.65em;

    &.warning {
      color: var(--red);
      font-weight: 600;
      margin-bottom: 2rem;
    }
  }

  h2 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 1em;
    text-transform: uppercase;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  width: 100%;
`;

export default DeleteCommentDialog;
